import api from 'api'
import { toCamelcaseKeys } from 'lib/string'

export type WorkAuthorizationExpirationRow = {
  workerId: number
  workerName: string
  workerEmail: string
  workerStatus: string
  workerW2Status: string
  workerMarket: string
  workerW2States: string[]
  i9WorkAuthorizationExpirationDate: string
  listADocumentExpiration: string | null
  listADocumentType: string | null
  listADocumentFileUrls: string[]
  listBDocumentExpiration: string | null
  listBDocumentType: string | null
  listBDocumentFileUrls: string[]
  listCDocumentExpiration: string | null
  listCDocumentType: string | null
  listCDocumentFileUrls: string[]
  suppBDocumentExpiration: string | null
  suppBDocumentType: string | null
  suppBDocumentFileUrls: string[]
  suppBPdfUrl: string | null
}

export type WorkAuthorizationExpirationReport = WorkAuthorizationExpirationRow[]

export const getWorkAuthorizationExpirationReport =
  async (): Promise<WorkAuthorizationExpirationReport> => {
    const result = await api.get<unknown>(
      '/admin/i9/work_authorization_expiration_report'
    )
    return toCamelcaseKeys(result.data, {
      deep: true,
    }) as WorkAuthorizationExpirationReport
  }
